<template>
    <div class="role-select" data-testid="user-role__select">
        <Select v-bind="$attrs">
            <Option
                v-for="role in userRoles"
                :key="role._id"
                class="role-select-option"
                :value="role._id"
                :title="role.name"
            >
                {{ role.name }}
            </Option>
        </Select>
    </div>
</template>

<script lang="ts">
export default {
    name: "UserRoleSelect",
    inheritAttrs: false,
    computed: {
        userRoles() {
            return this.$store.state.roles.roles;
        }
    }
};
</script>
